import React from 'react';
import './loading.css';

export const Spinner = _ => <div className="c-spinner">Loading...</div>;



// WEBPACK FOOTER //
// ./src/components/loading.js